import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker as MUIDateTimePicker, DateTimePickerProps as MUIDateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

export interface DateTimePickerProps<TDate> extends MUIDateTimePickerProps<TDate> {
  mobile?: boolean
  fullWidth?: boolean
  gutterBottom?: boolean
}

function DateTimePicker<TDate> (props: DateTimePickerProps<TDate>): JSX.Element {
  const { fullWidth, mobile, sx, gutterBottom, ...rest } = props

  const styles = React.useMemo(() => ({
    ...(fullWidth ? { width: '100%' } : {}),
    ...(gutterBottom ? { marginBottom: '1rem' } : {}),
    ...sx
  }), [fullWidth, gutterBottom, sx])

  const Component = mobile ? MobileDateTimePicker : MUIDateTimePicker

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Component sx={styles}
      {...rest}
    />
    </LocalizationProvider>
  )
}

export default DateTimePicker
